import { Component, OnInit,ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import 'rxjs/add/observable/of';
import { BaseService } from '../../../shared/services/base.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { ValidationService } from '../../../shared/services/validation.service';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { Page } from '../../../models/list/page.model';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { UserUrl } from '../../../shared/urls/user.url';

import { InvoiceListModel } from '../../../models/payment/invoice.model';
import { AccountPaymentService } from './account-payment.service';

@Component({
  selector: 'account-payment',
  templateUrl: './account-payment.component.html',
  providers: [AccountPaymentService]
})

export class AccountPaymentComponent implements OnInit {
  
  @ViewChild('invoice') listInvoice;
  @ViewChild('payinvoice') payInvoice;    
  public patientId = this.activateRoute.snapshot.queryParams.patientId;
  constructor(public utility: Utility,
              public baseService: BaseService,
              public dialogService: DialogService,
              private activateRoute: ActivatedRoute,
              private router: Router,
              public accountPaymentService: AccountPaymentService) {
  }

  ngOnInit() {
    this.setPage({offset: 0});        
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  setPage(pageInfo) {
    if (!pageInfo) {
      return;
    }
  }
}





// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/account-payment/account-payment.component.ts